import React, { useCallback, useEffect, useMemo,useState } from "react";

import { Table } from "react-bootstrap";
import { routes } from '../routes/routes-names';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { organizationService } from "../lib/api/organization";
import { RegPayDetailsFormType } from "../types/common";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import OrgPrintCertificateComponent from "./OrgPrintCertificateComponent";
import { LocalStorageManager } from '../lib/localStorage-manager';


const OrganizationPayment: React.FC = () => {
  type Organization= {
  id: number;
  organizationName: string;
  email: string;
  remarks:string;
  contactNumber: string;
  paymentStatus: string;
  organizationType: string;
  registartionCertificate: string;
  coveringLetter:string;
  declarationSheet:string;
}
  const navigate = useNavigate();
  const [expandedRow, setExpandedRow] = useState<number | null>(null);
  const [organizations, setOrganizations] = useState<Organization|null>();
    const [orgRegNumber, setOrgRegNumber] = useState<any>();
    const [orgName, setOrgName] = useState<any>();
    const [orgDate, setOrgDate] = useState<any>();
    const [orgExpDate, setOrgExpDate] = useState<any>();
  const location = useLocation();
  
   const [isLoader, setIsLoader] = useState(true);

    const getDate = moment().format('DD-MM-YYYY');
    const [regPayDetails, setRegPayDetails] = useState<RegPayDetailsFormType | null>(null);
    
    const [payUrl, setPayUrl] = useState('');
    const [payOrderId, setPayOrderId] = useState('');
    
    
  const toggleRow = (id: number) => {
  setExpandedRow(expandedRow === id ? null : id);
     
  };
const PayAndContinueForm = useCallback(async (payUrl: any, payOrderId: any) => {
        try {
            if (payUrl) {
              const orgData =  localStorage.getItem("orgdata");
              if (orgData) {
                  const retrievedObject = JSON.parse(orgData);
                  // Avoid logging sensitive org details
                  const orgPrimaryId=retrievedObject.id;
                  secureLocalStorage.setItem("respOrderKeyId",payOrderId);
                  secureLocalStorage.setItem("respOrganizationId",orgPrimaryId);
                  secureLocalStorage.setItem("regType",'organization');
                  window.open(payUrl, '_self', 'noreferrer');
              }
            } else {
                alert("Error Msg ");
            }
        } catch (err) {
            // Avoid logging sensitive payment errors
        }
    }, []);

  const getOrganizationRegFeeDetails = useCallback(async () => {
        try {
          const orgData =  localStorage.getItem("orgdata");
              if (orgData) {
                  const retrievedObject = JSON.parse(orgData);
                 const orgPrimaryId=retrievedObject.id;
                 setOrgName(retrievedObject.organizationName);
                                  const apprDate = moment(retrievedObject.approvalDate);
                                  const apprDateStr = moment(retrievedObject.approvalDate).format('DD-MM-YYYY');
                                  const futureDate = apprDate.add(5, 'years');
                 
                                   setOrgDate(apprDateStr);
                                   setOrgExpDate(moment(futureDate).format('DD-MM-YYYY'));
                                   setOrgRegNumber(retrievedObject.tgmcRegNumber);
            const provData = await organizationService.getOrganizationFeeDetails(orgPrimaryId);
            if (provData.data) {
                setRegPayDetails({
                    registrationFee: provData.data.registrationFee,
                    noOfApprovedDocs: provData.data.noOfApprovedDocs,
                    totalAmount: provData.data.totalAmount,
                    extraCharges: provData.data.extraCharges,
                    fullName: provData.data.fullName,
                    phoneNo: provData.data.mobileNo,
                    address: provData.data.address,
                });
                setOrganizations(provData.data.org);
                setPayUrl(provData.data.redirectUrl);
                setPayOrderId(provData.data.orderKeyId);
             
            }
          }

        } catch (err: any) {
            // Avoid logging sensitive error details
        } finally {
            setIsLoader(false);
        }
    }, []);

   useEffect(() => {
    setOrganizations(null);
    getOrganizationRegFeeDetails();
    }, []);
  

  return (
    <div className="cme-page">
      <div className="cme-container mt-1">
      <h2 className="cme-title">Organization Status Details</h2>
      <Table bordered hover responsive >
        <thead className="table-primary">
          <tr>
            <th>Organization Name</th>
            <th>Organization Type</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Status</th>
            <th>Actions</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {organizations&&(
            <React.Fragment key={organizations.id}>
              <tr>
         
                <td>{organizations.organizationName}</td>
                <td>{organizations.organizationType}</td>
                <td>{organizations.email}</td>
                <td>{organizations.contactNumber}</td>
                <td>
                  <span
                    className={`badge ${
                      organizations.paymentStatus === "pen"
                        ? "bg-warning text-dark"
                        : "bg-success"
                    }`}
                  >
                    {organizations.paymentStatus ==='pen' &&"Pending"}
                    {organizations.paymentStatus ==='rej' &&"Rejected"}
                    {organizations.paymentStatus ==='ver' &&"Verified"}
                    {organizations.paymentStatus ==='apr' &&"Approved"}
                    
                  </span>
                </td>
                       {organizations.paymentStatus==='ver'&&
                <td
                  onClick={() => toggleRow(organizations.id)}
                  style={{ cursor: "pointer", textAlign: "center" }}
                >
                  <button>Click To Pay </button>
                </td>}
                       {organizations.paymentStatus==='apr'&&
                  <td
                  onClick={() => toggleRow(organizations.id)}
                  style={{ cursor: "pointer", textAlign: "center" }}
                >
                  <button className="primary-btn btn-sm" style={{ padding: "6px 14px", fontSize: "13px" }}>
                    Click To Print
                  </button>
                </td>
                  }


                {organizations.paymentStatus == 'rej' && 
                  <td>
                  <Link to={'/mainLayout/edit-organization'} className='btn btn-primary btn-sm me-3'>Edit</Link>
                  </td>
                }

                {organizations.paymentStatus == 'rej' && 
                <td>
                <p>{organizations.remarks}</p>
                   </td>                                       
                  }
          
              </tr>
              {expandedRow === organizations.id && (
                <>{organizations.paymentStatus==='ver' &&<tr>
                  <td colSpan={6}>
                    <section className='gray-banner'>
                                    <div>
                                        <div className="card mb-3 shadow border-0">
                                            <div className="card-header">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div>
                                                        <h3 className="fs-18 fw-700 mb-0">Payment details</h3>
                                                    </div>
                                                    <div></div>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="d-flex">
                                                    <div className="col pe-2 border-end">
                                                        <div className="row mb-3">
                                                            <div className="col-4"><label htmlFor="">Registration Type</label></div>
                                                             <div className="col fs-14">Organization Name</div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <div className="col-4"><label htmlFor="">Full Name</label></div>
                                                            <div className="col fs-14">{regPayDetails?.fullName}</div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <div className="col-4"><label htmlFor="">Mobile No</label></div>
                                                            <div className="col fs-14">{regPayDetails?.phoneNo}</div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <div className="col-4"><label htmlFor="">Address</label></div>
                                                            <div className="col fs-14">{regPayDetails?.address} </div>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-end ps-2">
                                                        <div>
                                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                                <label htmlFor="">Registration Type: </label>
                                                                <div className="fs-14  fw-700">
                                                                   </div> 
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                                <label htmlFor="">Registration Fee</label>
                                                                <div className="fs-14"><i className="bi-currency-rupee"></i> {regPayDetails?.registrationFee}/-</div>
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                                <label htmlFor="">Charges</label>
                                                                <div className="fs-14"><i className="bi-currency-rupee"></i> {regPayDetails?.extraCharges}/-</div>
                                                            </div>
                                                            <hr />
                                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                                <label htmlFor="">Total</label>
                                                                <div className="fs-14"><i className="bi-currency-rupee"></i> {regPayDetails?.totalAmount}/-</div>
                                                            </div>
                                                            <hr className="mb-0" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-footer text-end py-3">
                                                {/*<button type="button" onClick={() => navigate(-1)} className="btn btn-primary me-3">Back</button>*/}
                                                <button type="button"   onClick={() => PayAndContinueForm(payUrl, payOrderId)} className="cme-header">Continue & Pay</button>
                                            </div>
                                        </div>
                                        <div className="card shadow border-0 mb-3">
                                            <div className="card-body d-flex justify-content-between align-items-center">
                                                <div className="fs-13 d-flex">
                                                    <Link target={'_blank'} className="pe-2" to={'/terms-and-conditions'}>Terms and Conditions</Link>
                                                    <Link target={'_blank'} className="px-2" to={'/privacy-policy'}>Privacy Policy</Link>
                                                    <Link target={'_blank'} className="ps-2" to={'/refund'}>Refund</Link>
                                                </div>
                                                {/* 
                                                <div>
                                                    <img src={rupaylogo} alt="" width="55px" className="pe-2" />
                                                    <img src={visalogo} alt="" width="55px" className="pe-2" />
                                                    <img src={mastercardlogo} alt="" width="55px" className="pe-2" />
                                                    <img src={payglogo} alt="" width="55px" className="pe-2" />
                                                    <img src={sslsecurelogo} alt="" width="55px" className="" />
                                                </div>
                                                */}
                                            </div>
                                        </div>
                    
                                    </div>
                                </section>
                  </td>
                  </tr>}
                  {organizations.paymentStatus==='apr' &&<tr>
                  <td colSpan={6}>
      
                  <OrgPrintCertificateComponent 
                  orgName={orgName}
                  orgRegNumber={orgRegNumber}
                  orgDate={orgDate}
                  orgExpDate={orgExpDate}
                    />

                  </td>
                  </tr>
                  }
                  
                </>
              )}
            </React.Fragment>
          )}
        </tbody>
      </Table>

  </div>
  </div>
  );
};

export default OrganizationPayment;
